var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNavigation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 29,
    viewBox: "0 0 21 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4442 0C4.68517 0 0 4.86381 0 10.8422C0 20.4558 9.39784 28.0219 9.79796 28.3394L10.4442 28.8521L11.0901 28.3394C11.4902 28.0218 20.8884 20.4558 20.8884 10.8422C20.8884 4.86374 16.2033 0 10.4442 0ZM10.4434 26.0287C8.38501 24.1899 2.12798 18.0087 2.12798 10.8422C2.12798 6.08179 5.85809 2.20909 10.4442 2.20909C15.0294 2.20909 18.7604 6.08186 18.7604 10.8422C18.7604 17.9933 12.5009 24.187 10.4434 26.0287Z",
    fill: "#757575"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6301 16.2293C7.77285 16.2293 5.44824 13.8215 5.44824 10.8617C5.44824 7.9018 7.77278 5.49365 10.6301 5.49365C13.4873 5.49365 15.8119 7.90173 15.8119 10.8617C15.8119 13.8215 13.4873 16.2293 10.6301 16.2293ZM10.6301 7.25413C8.70985 7.25413 7.14757 8.87255 7.14757 10.8618C7.14757 12.8508 8.70985 14.469 10.6301 14.469C12.5503 14.469 14.1125 12.8508 14.1125 10.8618C14.1125 8.87247 12.5503 7.25413 10.6301 7.25413Z",
    fill: "#757575"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigation);
export default __webpack_public_path__ + "static/media/navigation.f05246ae2a26bea8bad324c1af4aa82a.svg";
export { ForwardRef as ReactComponent };